import script from "./SubscriptionAdminBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubscriptionAdminBanner.vue?vue&type=script&lang=ts&setup=true"

import "./SubscriptionAdminBanner.vue?vue&type=style&index=0&id=4f69cbab&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f69cbab"]])

export default __exports__